import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-x-4" }
const _hoisted_4 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_5 = { class: "flex justify-end mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, {
    style: {"height":"calc(100vh - 80px)"},
    class: "bg-white"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "システム設定 > 作業員管理", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _ctx.searchForm,
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      label: "作業員名",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.searchForm.operator_name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.operator_name) = $event)),
                          placeholder: "作業員名(前方一致)",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      class: "w-24",
                      type: "primary",
                      onClick: _ctx.handleSearchButton
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("検索")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"padding-block":"0px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_table, {
              data: _ctx.mTableData,
              height: 'calc(100vh - 350px)'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "operator_code",
                  label: "作業員コード",
                  width: "320"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "operator_name",
                  label: "作業員名",
                  "min-width": "200"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "organization_name",
                  label: "所属会社",
                  "min-width": "280"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "telephone",
                  label: "電話番号",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "app_version",
                  label: "アプリバージョン",
                  width: "140"
                }),
                _createVNode(_component_el_table_column, {
                  label: "削除",
                  width: "60",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      link: "",
                      onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.mCurrentPage,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
              "page-size": _ctx.mPageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mPageSize) = $event)),
              "page-sizes": [10, 20, 50],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.mTotalRecords,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_el_footer, { style: {"height":"20px"} })
    ]),
    _: 1
  }))
}